import { RefObject, useEffect, useRef } from 'react';

export const useScrollToLatestItem = (
  items: readonly unknown[],
  containerRef: RefObject<HTMLDivElement | null>,
  setExpanded: (value: number | false) => void,
): void => {
  const prevLengthRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    const prevLength = prevLengthRef.current;
    if (prevLength !== undefined && prevLength < items.length) {
      setExpanded(items.length - 1);
      const el = containerRef.current;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    }
    prevLengthRef.current = items.length;
  }, [items]);
};
